// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__28Q9D","inputWrap":"Table_inputWrap__3hozn","col":"Table_col__34OEx","bmiTooltip":"Table_bmiTooltip__38LHO"};